const setupCheckoutInlineErrors = () => {
    const isCheckout = document.body.classList.contains('woocommerce-checkout');
    if (!isCheckout) {
        return;
    }

    const disableScrollToNotices = () => {
        if (!window.jQuery) {
            return false;
        }
        if (window.jQuery.scroll_to_notices) {
            window.jQuery.scroll_to_notices = () => {};
        }
        return true;
    };

    const scrollToField = (fieldElement) => {
        if (!fieldElement) {
            return;
        }

        const doScroll = () => {
            const rect = fieldElement.getBoundingClientRect();
            const offset = 120;
            const targetTop = window.pageYOffset + rect.top - offset;
            window.scrollTo({
                top: Math.max(targetTop, 0),
                behavior: 'smooth',
            });
        };

        requestAnimationFrame(() => {
            requestAnimationFrame(doScroll);
        });
    };

    let retryTimer = null;
    const handleErrors = () => {
        const errorItems = document.querySelectorAll('.woocommerce-error li');
        const fieldsWithErrors = new Set();
        const errorFields = [];
        let needsRetry = false;

        errorItems.forEach((error) => {
            const field = error.getAttribute('data-field');
            if (!field) {
                return;
            }

            const fieldId = `${field}_field`;
            const fieldElement = document.getElementById(fieldId);
            if (!fieldElement) {
                needsRetry = true;
                return;
            }

            fieldsWithErrors.add(fieldId);

            const existingError = fieldElement.querySelector(
                '.checkout-inline-error-message'
            );
            if (existingError) {
                existingError.remove();
            }

            const messageHtml = error.innerHTML.trim();
            const messageText = error.textContent.trim();
            const message = messageHtml || messageText;
            if (!message) {
                return;
            }

            const errorElement = document.createElement('p');
            errorElement.classList.add('checkout-inline-error-message');
            errorElement.innerHTML = message;
            fieldElement.appendChild(errorElement);
            fieldElement.classList.add('woocommerce-invalid');
            errorFields.push(fieldElement);

            error.remove();
        });

        if (!errorItems.length) {
            const invalidRequired = document.querySelectorAll(
                '.form-row.woocommerce-invalid-required-field'
            );
            invalidRequired.forEach((fieldElement) => {
                const fieldId = fieldElement.id;
                if (!fieldId) {
                    return;
                }
                fieldsWithErrors.add(fieldId);
                errorFields.push(fieldElement);

                if (!fieldElement.querySelector('.checkout-inline-error-message')) {
                    const errorElement = document.createElement('p');
                    errorElement.classList.add('checkout-inline-error-message');
                    errorElement.textContent = 'To pole jest wymagane.';
                    fieldElement.appendChild(errorElement);
                }

                fieldElement.classList.add('woocommerce-invalid');
            });
        }

        document
            .querySelectorAll('.form-row.woocommerce-invalid')
            .forEach((fieldElement) => {
                const fieldId = fieldElement.id;
                if (!fieldId || fieldsWithErrors.has(fieldId)) {
                    return;
                }
                const errorElement = fieldElement.querySelector(
                    '.checkout-inline-error-message'
                );
                if (errorElement) {
                    errorElement.remove();
                }
                fieldElement.classList.remove('woocommerce-invalid');
            });

        const findFirstVisibleError = () => {
            if (errorFields.length) {
                return errorFields[0] || null;
            }
            return (
                document.querySelector(
                    '.form-row.woocommerce-invalid-required-field, .form-row.woocommerce-invalid'
                ) || null
            );
        };

        const firstErrorField = findFirstVisibleError();

        if (firstErrorField) {
            setTimeout(() => {
                scrollToField(firstErrorField);
            }, 120);
        }

        if (needsRetry && !retryTimer) {
            retryTimer = window.setTimeout(() => {
                retryTimer = null;
                handleErrors();
            }, 200);
        }
    };

    handleErrors();

    const updateSummaryScroll = () => {
        document
            .querySelectorAll('.js-checkout-order-items')
            .forEach((element) => {
                const hasScroll = element.scrollHeight > element.clientHeight + 1;
                element.classList.toggle('has-scroll', hasScroll);
            });
    };

    let summaryRafId = null;
    const scheduleSummaryScrollUpdate = () => {
        if (summaryRafId !== null) {
            return;
        }
        summaryRafId = requestAnimationFrame(() => {
            summaryRafId = null;
            updateSummaryScroll();
        });
    };

    scheduleSummaryScrollUpdate();

    let eventsBound = false;
    const bindJqueryCheckoutHooks = () => {
        if (!window.jQuery || eventsBound) {
            return false;
        }

        eventsBound = true;
        disableScrollToNotices();
        window.setTimeout(disableScrollToNotices, 0);
        window.setTimeout(disableScrollToNotices, 150);

        window.jQuery(document.body).on('updated_checkout', () => {
            disableScrollToNotices();
            handleErrors();
            scheduleSummaryScrollUpdate();
        });

        window.jQuery(document.body).on('checkout_error', () => {
            disableScrollToNotices();
            handleErrors();
            scheduleSummaryScrollUpdate();
        });

        window.jQuery(document.body).on('submit', 'form.checkout', () => {
            window.setTimeout(() => {
                handleErrors();
                scheduleSummaryScrollUpdate();
            }, 150);
        });

        return true;
    };

    if (!bindJqueryCheckoutHooks()) {
        let attempts = 0;
        const maxAttempts = 50;
        const waitForJquery = window.setInterval(() => {
            attempts += 1;
            if (bindJqueryCheckoutHooks() || attempts >= maxAttempts) {
                window.clearInterval(waitForJquery);
            }
        }, 100);
    }

    window.addEventListener('resize', scheduleSummaryScrollUpdate);

    const observer = new MutationObserver((mutations) => {
        let shouldHandle = false;
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) {
                    return;
                }
                if (
                    node.matches?.('.woocommerce-error') ||
                    node.querySelector?.('.woocommerce-error')
                ) {
                    shouldHandle = true;
                }
            });
        });
        if (shouldHandle) {
            handleErrors();
        }
    });
    const observerRoot =
        document.querySelector('form.checkout') ||
        document.querySelector('.woocommerce-checkout');

    if (observerRoot) {
        observer.observe(observerRoot, { childList: true, subtree: true });
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCheckoutInlineErrors, {
        once: true,
    });
} else {
    setupCheckoutInlineErrors();
}
